import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'

import { Provider } from 'react-redux'
import { IntlProvider } from 'react-redux-multilingual'
import { translations } from './languages/Translations'

import store from './store';
import ClearSaleInitializer from './components/ClearSaleInitializer'

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider translations={translations}>
      <ClearSaleInitializer />
      <App />
    </IntlProvider>
  </Provider>,
  document.getElementById('root')
)
